
import { mapOrderWindowData } from "./index";

export const getEffectiveOrderPayload = (localInstrument, side, userSettings, positionsArray) => {
    const matchingPosition = positionsArray.find((p) => (
        String(p.token) === String(localInstrument.token) ||
        String(p.instrument_token) === String(localInstrument.token)
    ))
    if (matchingPosition && matchingPosition.product) {
        const withProduct = { ...localInstrument, product: matchingPosition.product };
        return mapOrderWindowData(withProduct, side, 'POSITION', userSettings?.order_type, userSettings?.product_type);
    }
    return mapOrderWindowData(localInstrument, side, 'DEFAULT', userSettings?.order_type, userSettings?.product_type);
};
